import { createActions } from '../utils/actions';

const { actions: user } = createActions('user')
  .addAsync('changeTheme')
  .addAsync('getBetaAccess')
  .addAsync('getConfig')
  .addAsync('getSubscriptions')
  .addAsync('getUserData')
  .addAsync('getUserProfile')
  .add('setProfileValue');

export default user;
